import {CALIBRATION_BOOKMARKLET_START_YEAR} from "./constants";

export function getCalibrationStartYear(years: number[]|string[]) {
    const numericYears = years
        .map(year => parseInt(year.toString(), 10))
        .filter(year => Number.isFinite(year));

    if (!numericYears.length) return CALIBRATION_BOOKMARKLET_START_YEAR;

    return Math.min(...numericYears);
}
